import { __awaiter, __decorate } from "tslib";
/**
 * See https://fdc3.finos.org/docs/fdc3-intro, and https://github.com/finos/FDC3/tree/master/src/api
 */
import { addIntentListener, fdc3Ready, findIntent, findIntentsByContext, getOrCreateChannel, getInfo, joinChannel, raiseIntent, raiseIntentForContext, versionIsAtLeast, } from '@finos/fdc3';
import { observable } from '@microsoft/fast-element';
import { DI } from '@microsoft/fast-foundation';
import { logger } from '../utils';
/**
 * The FDC3 implementation.
 * @internal
 */
class FDC3Service {
    constructor() {
        this.isReady = false;
        this.connect();
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.isReady = false;
                yield fdc3Ready();
                logger.debug('fdc3 connection success');
            }
            catch (err) {
                logger.error('fdc3 connection error', err);
                throw err;
            }
        });
    }
    addIntentListeners(listeners) {
        listeners.forEach((handler, intent) => {
            const listener = addIntentListener(intent, handler);
            logger.debug(`fdc3 addIntentListener for '${intent}', ${listener}`);
        });
    }
    findIntent(intent, context) {
        logger.debug(`fdc3 findIntent '${intent}' '${context}'`);
        return findIntent(intent, context);
    }
    findIntentsByContext(context) {
        logger.debug(`fdc3 findIntentsByContext '${context}'`);
        return findIntentsByContext(context);
    }
    raiseIntent(context, intent) {
        if (getInfo && versionIsAtLeast(getInfo(), '1.2')) {
            logger.debug(`fdc3 raiseIntentForContext '${context}'`);
            return raiseIntentForContext(context);
        }
        if (intent) {
            logger.debug(`fdc3 raiseIntent '${intent}' '${context}'`);
            return raiseIntent(intent, context);
        }
        logger.error(`fdc3 unable to raiseIntent using context '${context}' and intent '${intent}'.`);
    }
    joinChannel(channelId) {
        logger.debug(`fdc3 joinChannel '${channelId}'`);
        return joinChannel(channelId);
    }
    getOrCreateChannel(channelId) {
        logger.debug(`fdc3 getOrCreateChannel '${channelId}'`);
        return getOrCreateChannel(channelId);
    }
    broadcastOnChannel(channelId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const channel = yield this.getOrCreateChannel(channelId);
            logger.debug(`fdc3 broadcast '${channelId}' '${context}'`);
            channel.broadcast(context);
        });
    }
}
__decorate([
    observable
], FDC3Service.prototype, "isReady", void 0);
/**
 * The DI token for the FDC3Service interface.
 * @internal
 */
export const FDC3 = DI.createInterface((x) => x.singleton(FDC3Service));
